/**
 * CSS overflow values that create a vertical scroll container.
 */
export const SCROLLABLE_OVERFLOW_VALUES = ['auto', 'overlay', 'scroll'] as const;

const SCROLLABLE_OVERFLOW_VALUES_SET = new Set<string>(SCROLLABLE_OVERFLOW_VALUES);

/**
 * Check whether a CSS overflow value should be treated as vertically scrollable.
 */
export function isScrollableOverflowValue(overflow: string | null | undefined): boolean {
    if (!overflow) {
        return false;
    }

    return SCROLLABLE_OVERFLOW_VALUES_SET.has(overflow);
}
